import { createSvgIcon } from "@mui/material";

const MembersIcon = createSvgIcon(
    <svg id="Ebene_2" xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 68.64 31.22"
        stroke="currentColor"
        fill="currentColor"
    >
        <g id="Ebene_1-2">
            <path d="M47.89 31.22c1.08 0 1.95-.87 1.95-1.95 0 0 .06-2.21 0-3.9-.16-4.54-5.49-5.85-7.81-5.85-1.68 0-3.9-1.75-3.9-3.9v-.25c1.77-2.09 2.93-5.24 2.93-7.56 0-3.77-.98-7.81-6.83-7.81S27.4 4.03 27.4 7.81c0 2.32 1.16 5.47 2.93 7.56v.25c0 2.16-1.71 3.9-3.9 3.9-3.01 0-7.71 1.99-7.81 5.85-.03 1.13 0 3.9 0 3.9 0 1.08.87 1.95 1.95 1.95h27.32ZM16.62 25.32c.06-2.43 1.38-4.31 3.18-5.62-.83-.26-1.64-.37-2.21-.37-1.26 0-2.93-1.31-2.93-2.93v-.18c1.33-1.57 2.2-3.93 2.2-5.68 0-2.83-.73-5.86-5.13-5.86S6.6 7.71 6.6 10.54c0 1.74.87 4.11 2.2 5.68v.18c0 1.62-1.29 2.93-2.93 2.93-2.26 0-5.79 1.5-5.87 4.4-.01.85 0 2.93 0 2.93 0 .81.66 1.47 1.47 1.47h15.14v-2.81ZM68.62 23.73c-.12-3.41-4.12-4.4-5.86-4.4-1.26 0-2.93-1.31-2.93-2.93v-.18c1.33-1.57 2.2-3.93 2.2-5.68 0-2.83-.73-5.86-5.13-5.86s-5.13 3.03-5.13 5.86c0 1.74.87 4.11 2.2 5.68v.18c0 1.62-1.29 2.93-2.93 2.93-.66 0-1.44.13-2.2.39 1.86 1.4 2.92 3.33 3 5.58.03.95.03 2.02.02 2.83h15.3c.81 0 1.47-.66 1.47-1.47 0 0 .04-1.66 0-2.93Z" />
        </g>
    </svg>

    , 'MembersIcon')

export default MembersIcon
